
import { CommonModule } from "@angular/common";
import { Component, Inject } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MatBadgeModule } from "@angular/material/badge";
import { MatButtonModule } from "@angular/material/button";
import { MatOptionModule } from "@angular/material/core";
import { MAT_DIALOG_DATA, MatDialog, MatDialogModule, MatDialogRef } from "@angular/material/dialog";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIcon, MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatSidenav, MatSidenavContainer } from "@angular/material/sidenav";
import { MatSlideToggle } from "@angular/material/slide-toggle";
import { MatSnackBar } from "@angular/material/snack-bar";
import { MatTooltipModule } from "@angular/material/tooltip";
import { NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from "@ng-select/ng-select";
import { SystemServicesService } from "../system-services.service";

@Component({
  selector: 'app-form-system-configuration-modal',
  styleUrl: './form-system-configuration.component.scss',
  templateUrl: './form-system-configuration.component.html',
  standalone: true,
  imports: [
    CommonModule,
    MatDialogModule,
    MatButtonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatIcon,
    MatSelectModule,
    MatOptionModule,
    MatTooltipModule,
    MatButtonModule,
    MatIconModule,
    MatSidenav,
    MatSidenavContainer,
    FormsModule,
    NgLabelTemplateDirective,
    NgOptionTemplateDirective,
    NgSelectComponent,
    MatSelectModule,
    MatBadgeModule,
    MatSlideToggle,
  ],
})
export class FormSystemConfigurationComponent {

  hostControl = new FormControl('', Validators.required);
  userControl = new FormControl('', Validators.required);
  passwordControl = new FormControl('', Validators.required);
  

  //Formulario
  formData = new FormGroup({
    hostControl: this.hostControl,
    userControl: this.userControl,
    passwordControl: this.passwordControl,
  })

  hide = true; 

  constructor(
    private dialog: MatDialog,
    public dialogRef: MatDialogRef<any>,
    private snackBar: MatSnackBar,  
    private readonly systemservicesService: SystemServicesService,
    @Inject(MAT_DIALOG_DATA) public data: any // Optional: if you want to pass data
  ){
  }

  ngAfterViewInit():void {
      this.dialogRef.updateSize("90%")
      this.onGetConfiguration();
  }

  onGetConfiguration(){
    this.systemservicesService.getConfiguration().subscribe((data:any) => {
      if(data){
        this.initForm(data)
      }
    });
  }

  initForm(data){
    if(data.id){
      Promise.resolve().then(() => {
        this.formData.setValue({
          hostControl: data.host,
          userControl: data.user,
          passwordControl: data.password,
        })
      });
    }
  }

  resetForm(){
    this.formData.setValue({
      hostControl: null,
      userControl: null,
      passwordControl: null,
    })
  }

  onSubmit() {
    if(!this.formData.valid){
      return;
    }

    return;
  }

  togglePasswordVisibility(): void {
    this.hide = !this.hide; // Cambia entre mostrar y ocultar
  }

}





